export const SERVER_URL = "https://do-calculate.com/api";

export const Money_Zakat_EndPoint = "calculate-money-zakat";
export const Gold_Zakat_EndPoint = "calculate-gold-zakat";
export const Gold_Karat_EndPoint = "calculate-gold-karat";
export const Silver_Zakat_EndPoint = "calculate-silver-zakat";
export const Fruits_Zakat_EndPoint = "calculate-fruits-zakat";
export const Trade_Zakat_EndPoint = "calculate-trade-zakat";
export const Animals_Zakat_EndPoint = "calculate-animals-zakat";
export const islamicCalculators = [
  {
    name: "Calculatrice de Zakat sur l'argent",
    link: "/calculator/fr/money-zakat/",
    description:
      "Utilisez cette calculatrice pour calculer la zakat sur l'argent et les dons selon les règles islamiques.",
      showMain: true
  },
  {
    name: "Calculatrice de Zakat sur l'or",
    link: "/calculator/fr/gold-zakat/",
    description:
      "Cette calculatrice calcule la zakat sur l'or et les bijoux selon les conditions religieuses.",
      showMain: true
  },
  {
    name: "Calculatrice de Zakat sur l'argent (métal)",
    link: "/calculator/fr/silver-zakat/",
    description:
      "Utilisez cette calculatrice pour calculer la zakat sur l'argent et les métaux précieux selon les règles islamiques.",
      showMain: true
  },
  {
    name: "Calculatrice de Zakat sur les fruits",
    link: "/calculator/fr/fruits-zakat/",
    description:
      "Cette calculatrice calcule la zakat sur les fruits et les récoltes agricoles selon les règles religieuses.",
      showMain: true
  },
  {
    name: "Calculatrice de Zakat sur le commerce",
    link: "/calculator/fr/trade-zakat/",
    description:
      "Utilisez cette calculatrice pour calculer la zakat sur le commerce et les actifs d'investissement.",
      showMain: true
  },
  {
    name: "Calculatrice de Zakat sur les animaux",
    link: "/calculator/fr/animals-zakat/",
    description:
      "Cette calculatrice calcule la zakat sur les animaux et le bétail selon les règles religieuses.",
  },
  {
    name: "Convertisseur de carat d'or",
    link: "/calculator/fr/gold-karat/",
    description:
      "Utilisez cette calculatrice pour convertir l'unité de carat d'or en d'autres unités comme le gramme et l'once.",
      showMain: true
  },
  {
    name: "Adhkars du Matin",
    link: "/calculator/fr/athkar-alsabah/",
    description:
      "Adhkars du matin de Hisn al-Muslim avec compteur automatique pour enregistrer chaque dhikr.",
    showMain: true
  },
  {
    name: "Adhkars du Soir",
    link: "/calculator/fr/athkar-almasaa/",
    description:
      "Adhkars du soir de Hisn al-Muslim avec compteur automatique pour enregistrer chaque dhikr.",
    showMain: true
  },
  {
    name: "Calculatrice de l'Heure du Tahajjud",
    link: "/calculator/fr/tahajjud-time/",
    description:
      "Calculez l'heure du dernier tiers de la nuit pour accomplir la prière du Tahajjud en entrant les heures du Maghrib et du Fajr.",
    showMain: true
  },];
